import React, { useEffect, useState } from "react";
import ReviewCard from "../ReviewCard";
import { http } from "../../axios/axios";
import { AnimatePresence } from "framer-motion";
import ReviewFormModal from "../modal/ReviewFormModal";
import { Helmet } from "react-helmet-async";

const Reviews = () => {
  const [allReviews, setAllReviews] = useState([]);
  const [reviewModalOpen, setReviewModalOpen] = useState(false);
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    fetchSeo();
  }, []);

  const fetchSeo = async () => {
    try {
      const { data } = await http.get("/seo/Reviews");
      console.log(data)
      setSeo(data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const seoData = seo || {
    metaTitle: "",
    metaDescription: "",
    metaTags: [],
    schemaScript: null,
  };

  const schemaScript = seoData?.schemaScript
    ? typeof seoData.schemaScript === "string"
      ? seoData.schemaScript
      : JSON.stringify(seoData.schemaScript)
    : null;
  const fetchReviews = async () => {
    try {
      const res = await http.get("reviews/approved");
      setAllReviews(res.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  const onClose = () => {
    setReviewModalOpen(false);
  };
  return (
    <>
      <Helmet>
        <title>{seo?.metaTitle}</title>
        <meta name="description" content={seoData?.metaDescription} />
        <meta
          name="keywords"
          content={
            Array.isArray(seoData?.metaTags)
              ? seoData?.metaTags.join(", ")
              : seoData?.metaTags
          }
        />

        {schemaScript && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: schemaScript }}
          />
        )}
      </Helmet>
      <div className="min-h-screen bg-white pb-20 font-sans">
        <header className="relative overflow-hidden bg-gradient-to-r from-slate-950 via-slate-900 to-blue-950 px-6 py-20 text-center">
          <div className="mx-auto max-w-7xl">
            <h1 className="font-serif text-4xl font-black uppercase tracking-tight text-white md:text-6xl">
              Customer <span className="text-blue-400">Reviews</span>
            </h1>

            <p className=" hidden md:block mt-6 text-lg leading-relaxed text-gray-300">
              Discover what our customers have to say about their experience
              with our CCTV surveillance, access control, biometric attendance,
              fire alarm, and integrated security solutions. Every review
              reflects our commitment to delivering reliable products,
              professional installation, and exceptional customer service. We
              value every customer's feedback as it helps us continually improve
              and assists others in choosing the right security solutions for
              their homes and businesses.
            </p>
          </div>
        </header>
        <div
          onClick={() => setReviewModalOpen(true)}
          className="cursor-pointer bg-blue-600 py-4 px-6 text-center text-white transition hover:bg-blue-700"
        >
          <p className="text-lg font-semibold">⭐ Share Your Experience</p>
          <p className="mt-1 text-sm text-blue-100">
            Click here to write a review
          </p>
        </div>
        <div className=" px-4 sm:px-6 lg:px-8">
          <div className="mt-12 grid items-start gap-8 md:grid-cols-2 lg:grid-cols-3 ">
            {allReviews.map((review) => (
              <ReviewCard
                key={review?._id}
                review={review}
              />
            ))}
          </div>
        </div>
        <AnimatePresence>
          {reviewModalOpen && (
            <ReviewFormModal onClose={onClose} onSuccess={fetchReviews} />
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export default Reviews;
